import { Injectable } from '@angular/core';
import * as interfaces from '@daas-consulting/core-cross-interfaces';
import { loader } from '@daas-consulting/production/shared/frontend/store';
import * as models from '@daas-consulting/security/audit/frontend/models';
import { Selector } from '@ngxs/store';
import { AuditDetailPreviewState } from './audit-detail_preview.state';
import { AuditDetailPreviewStateModel } from './audit-detail_preview.state-model';

@Injectable()
export class AuditDetailPreviewSelectors {
  @Selector([AuditDetailPreviewState])
  static item(state: AuditDetailPreviewStateModel): models.AuditModel | null {
    return state.activeItem;
  }

  @Selector([AuditDetailPreviewState])
  static activeFilters(
    state: AuditDetailPreviewStateModel
  ): interfaces.Criteria[] {
    return state.activeFilterCriteria;
  }

  @Selector([AuditDetailPreviewState])
  static items(state: AuditDetailPreviewStateModel): models.AuditModel[] {
    return state.items || [];
  }

  @Selector([AuditDetailPreviewState])
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  static detail(state: AuditDetailPreviewStateModel): any {
    return state.activeDetail;
  }

  @Selector([
    AuditDetailPreviewSelectors.detail,
    loader.selectors.LoaderSelectors.isLoading,
  ])
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  static hasDetail(state: any, isLoading: boolean): boolean {
    return typeof state !== 'undefined' && !isLoading;
  }

  @Selector([AuditDetailPreviewState])
  static activeDetail(state: AuditDetailPreviewStateModel): number {
    return state.activeDetailFilterModel?.seq as number;
  }
}
